export default {
	api: 'http://localhost:6100',
	loginTimeout: 86400
};
